import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { Toast } from "primereact/toast";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import LandingDropdown from "../../components/LandingDropdown/LandingDropdown";
import LandingNav from "../../components/LandingNav/LandingNav";
import LandingFooter from "../../components/LandingFooter/LandingFooter";
import LandingCopyright from "../../components/LandingCopyright/LandingCopyright";
import SEO from "../../../../components/SEO/SEO";
import N8nChatbot from "../../../../components/N8nChatbot/N8nChatbot";
import localeText from "../../../../locale";
import "../../landing.css";

const getPlans = () => [
  {
    key: "store",
    badge: localeText("lp2BadgeFree"),
    badgeBg: "var(--extra-green)",
    badgeColor: "#fff",
    name: "Store",
    desc: localeText("lp2PlanosStoreDesc"),
    items: [
      localeText("lp2PlanosStoreItem1"),
      localeText("lp2PlanosStoreItem2"),
      localeText("lp2PlanosStoreItem3"),
    ],
    cta: localeText("lp2PlanosStoreCta"),
    to: "/storeprofile",
    borderColor: "var(--extra-line)",
    highlight: false,
  },
  {
    key: "partner",
    badge: localeText("lp2BadgeProSilver"),
    badgeBg: "var(--extra-green-dark)",
    badgeColor: "#fff",
    name: "Partner",
    desc: localeText("lp2PlanosPartnerDesc"),
    items: [
      localeText("lp2PlanosPartnerItem1"),
      localeText("lp2PlanosPartnerItem2"),
      localeText("lp2PlanosPartnerItem3"),
    ],
    cta: localeText("lp2PlanosPartnerCta"),
    to: "/partner",
    borderColor: "var(--extra-line)",
    highlight: false,
  },
  {
    key: "seller",
    badge: localeText("lp2BadgeMostPopular"),
    badgeBg: "#DFF5E7",
    badgeColor: "var(--extra-green)",
    name: "Seller",
    desc: localeText("lp2PlanosSellerDesc"),
    items: [
      localeText("lp2PlanosSellerItem1"),
      localeText("lp2PlanosSellerItem3"),
    ],
    cta: localeText("lp2PlanosSellerCta"),
    to: "/sellerprofile",
    borderColor: "var(--extra-green-dark)",
    highlight: true,
  },
  {
    key: "manager",
    badge: localeText("lp2BadgeGeoGold"),
    badgeBg: "var(--extra-yellow)",
    badgeColor: "var(--extra-ink)",
    name: "Manager",
    desc: localeText("lp2PlanosManagerDesc"),
    items: [
      localeText("lp2PlanosManagerItem1"),
      localeText("lp2PlanosManagerItem2"),
      localeText("lp2PlanosManagerItem3"),
    ],
    cta: localeText("lp2PlanosManagerCta"),
    to: "/manager",
    borderColor: "var(--extra-yellow)",
    highlight: false,
  },
];

const PlanosPage = () => {
  const toast = useRef(null);
  const plans = getPlans();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const scrollToSection = (elementId) => {
    const element = document.getElementById(elementId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div>
      <SEO title="Planos | Extraconomy" description={localeText("lp2PlanosSeoDescription")} />
      <Toast ref={toast} />

      <div
        style={{ backgroundColor: "#3E8B5C", margin: "0" }}
        className="flex align-items-center justify-content-between nav-responsive sticky top-0 z-3"
      >
        <LandingNav scrollToSection={scrollToSection} />
        <Link
          className="hidden xl:flex font-bold gap-3 xl:px-6 px-4 border-noround border-none p-button-no-outline p-button-cart-hover align-items-center text-white"
          style={{ backgroundColor: "#2A2560", fontSize: "16px", height: "100%" }}
          to="/shop"
        >
          <i style={{ fontSize: "24px" }} className="pi pi-shopping-cart"></i>{" "}
          <span className="hidden xl:inline font-system">{localeText("toTheStore")}</span>
        </Link>
        <div className="xl:hidden flex h-full">
          <LandingDropdown scrollToSection={scrollToSection} />
        </div>
      </div>

      <div className="bg-white content-grid landing">
        {/* Hero */}
        <section className="full-width py-6 md:py-8" style={{ backgroundColor: "var(--extra-soft)" }}>
          <div className="flex flex-wrap align-items-center gap-2 text-sm">
            <Link to="/" className="font-semibold no-underline" style={{ color: "var(--extra-green)" }}>
              {localeText("home")}
            </Link>
            <i className="pi pi-chevron-right text-xs" style={{ color: "var(--extra-body)" }}></i>
            <span style={{ color: "var(--extra-body)" }}>{localeText("lp2PlanosBreadcrumb")}</span>
          </div>

          <div className="mt-5" style={{ maxWidth: "800px" }}>
            <p className="eyebrow-text m-0">{localeText("lp2PlanosEyebrow")}</p>
            <h1
              className="mt-3 font-bold title"
              style={{
                maxWidth: "14ch",
                fontSize: "clamp(40px, 5vw, 66px)",
                lineHeight: 1.06,
                letterSpacing: "-0.03em",
                color: "var(--extra-green)",
              }}
            >
              {localeText("lp2PlanosH1")}
            </h1>
            <p className="mt-4 text-lg line-height-3" style={{ maxWidth: "58ch", color: "var(--extra-body)" }}>
              {localeText("lp2PlanosHeroDesc")}
            </p>
          </div>
        </section>

        {/* Comparação de planos */}
        <section className="full-width bg-white py-6 md:py-8">
          <div style={{ maxWidth: "760px" }}>
            <p className="eyebrow-text m-0">{localeText("lp2PlanosCompareEyebrow")}</p>
            <h2
              className="mt-3 font-bold title text-3xl sm:text-4xl"
              style={{ color: "var(--extra-green)", letterSpacing: "-0.02em" }}
            >
              {localeText("lp2PlanosCompareTitle")}
            </h2>
            <p className="mt-3 text-lg line-height-3" style={{ color: "var(--extra-body)" }}>
              {localeText("lp2PlanosCompareDesc")}
            </p>
          </div>

          <div className="grid mt-5">
            {plans.map((plan) => (
              <div key={plan.key} className="col-12 md:col-6 xl:col-3">
                <div
                  className="landing-card-hover h-full flex flex-column border-round-lg p-4"
                  style={{
                    backgroundColor: plan.highlight ? "var(--extra-green-dark)" : "#fff",
                    border: `1px solid ${plan.borderColor}`,
                    boxShadow: plan.highlight ? "0 20px 44px rgba(30,40,30,.12)" : "none",
                  }}
                >
                  <span
                    className="inline-flex w-fit border-round-xl font-bold text-sm px-3 py-1"
                    style={{ backgroundColor: plan.badgeBg, color: plan.badgeColor }}
                  >
                    {plan.badge}
                  </span>
                  <div
                    className="font-bold text-2xl title mt-3"
                    style={{ color: plan.highlight ? "#fff" : "var(--extra-ink)" }}
                  >
                    {plan.name}
                  </div>
                  <p
                    className="mt-2 mb-0"
                    style={{ color: plan.highlight ? "rgba(255,255,255,0.75)" : "var(--extra-body)" }}
                  >
                    {plan.desc}
                  </p>
                  <div
                    className="flex-1 mt-4 flex flex-column gap-3 text-sm"
                    style={{ color: plan.highlight ? "rgba(255,255,255,0.9)" : "var(--extra-ink)" }}
                  >
                    {plan.items.map((item) => (
                      <div key={item}>{item}</div>
                    ))}
                  </div>
                  <Link
                    to={plan.to}
                    className="mt-5 inline-flex align-items-center justify-content-center border-round-md px-4 py-3 font-bold no-underline"
                    style={
                      plan.highlight
                        ? { backgroundColor: "var(--extra-yellow)", color: "var(--extra-ink)" }
                        : { border: "2px solid var(--extra-green)", color: "var(--extra-green)", backgroundColor: "#fff" }
                    }
                  >
                    {plan.cta}
                  </Link>
                </div>
              </div>
            ))}
          </div>
          <p className="mt-5 text-sm" style={{ color: "var(--extra-body)" }}>
            {localeText("lp2PlanosDisclaimer")}
          </p>
        </section>

        {/* CTA final */}
        <section className="full-width py-5" style={{ backgroundColor: "var(--extra-green)" }}>
          <div className="flex flex-column lg:flex-row align-items-start lg:align-items-center justify-content-between gap-4">
            <div>
              <h2 className="font-bold title text-3xl sm:text-4xl text-white m-0">
                {localeText("lp2PlanosCtaTitle")}
              </h2>
              <p className="mt-2 m-0" style={{ color: "rgba(255,255,255,0.75)", maxWidth: "48ch" }}>
                {localeText("lp2PlanosCtaDesc")}
              </p>
            </div>
            <Link
              to="/storeregister"
              className="inline-flex align-items-center gap-2 border-round-md px-5 py-3 font-bold no-underline flex-shrink-0"
              style={{ backgroundColor: "#fff", color: "var(--extra-green)" }}
            >
              {localeText("lp2PlanosCtaButton")} <i className="pi pi-arrow-right text-sm"></i>
            </Link>
          </div>
        </section>

        <LandingFooter />
        <LandingCopyright />
        <section
          className="py-4 full-width"
          style={{ backgroundColor: "#FFFFFF", color: "#5B6472", borderTop: "1px solid #DDE6E0" }}
        >
          <div className="flex flex-wrap align-items-center justify-content-between gap-3">
            <div className="flex flex-wrap align-items-center gap-2 text-xs" style={{ color: "#5B6472" }}>
              <span>EXTRACONOMY GLOBAL srl · Via Nomentana, 1018 - 00137 Roma (IT)</span>
              <span className="hidden md:inline">|</span>
              <span>P. Iva e C.F. 16948681008 | REA 1686351</span>
            </div>
            <Link to="/privacy" className="text-xs" style={{ color: "#5B6472" }}>
              Privacy Policy
            </Link>
          </div>
        </section>
      </div>

      <N8nChatbot isConfimeaCardVisible={false} />
    </div>
  );
};

export default PlanosPage;
